const React = require('react');
const useNativeEvents = require('./useNativeEvents');

const useModuleEvent = (name) => {
  const [identifier, setIdentifier] = React.useState(name);
  const enabled = React.useRef(typeof document !== 'undefined');
  const { addEventListener, removeEventListener } = useNativeEvents();

  const dispatch = React.useCallback((event, data) => {
    // istanbul ignore else
    if (enabled.current) {
      const e = new CustomEvent(`module:${identifier}:${event}`, {
        detail: data,
        composed: true,
      });

      document.dispatchEvent(e);
    }
  }, [identifier]);

  const listen = React.useCallback((event, listener, options) => {
    // istanbul ignore else
    if (enabled.current) {
      addEventListener(document, `module:${identifier}:${event}`, listener, options);
    }
  }, [identifier]);

  const unlisten = React.useCallback((event, listener, options) => {
    // istanbul ignore else
    if (enabled.current) {
      removeEventListener(document, `module:${identifier}:${event}`, listener, options);
    }
  }, [identifier]);

  return {
    dispatch,
    listen,
    unlisten,
    setIdentifier,
  };
};

module.exports = useModuleEvent;
